import { render, staticRenderFns } from "./certificateServices.vue?vue&type=template&id=4f28a322&scoped=true"
import script from "./certificateServices.vue?vue&type=script&lang=js"
export * from "./certificateServices.vue?vue&type=script&lang=js"
import style0 from "./certificateServices.vue?vue&type=style&index=0&id=4f28a322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28a322",
  null
  
)

export default component.exports